"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ScrollToFieldError;
var _react = require("react");
var _formik = require("formik");
function ScrollToFieldError() {
  const {
    submitCount,
    isValid,
    errors
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    if (isValid || !submitCount) return;
    const element = document.querySelector(`form *[name='${Object.keys(errors)[0]}']`);
    if (!element) return;
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }, [isValid, submitCount]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}